import { connect } from "redux-vue";
import PageTemplate from "./PageTemplate";
import * as moduleActions from "../actions/module";
import * as modulesActions from "../actions/modules";
import LoadingIndicator from "../components/LoadingIndicator";
import AxiosConfig from "../AxiosConfig";
import {debounce, getResourceLink} from "../helpers/tools";
import {getScreenSize} from "../helpers/screens";
import classNames from "classnames";
import ApiError from "../components/ApiError";
import Comments from "../components/Comments";
import CoursePageTour from "../components/CoursePageTour";
import ChangeManagement from "../components/ChangeManagement";

const CoursePage = {
  name: "CoursePage",
  props: [
    "module",
    "modules",
    "fetchModule",
    "startActivity",
    "completeActivity",
    "scoreActivity",
    "askAnExpert",
    "modules",
    "fetchModules",
    "user",
  ],

  data() {
    return {
      activity: null,
      lesson: null,
      nextActivityDialog: false,
      comingAssessmentDialog: false,
      reloadActivity: 0,
      playbackWindowHeight: 600,
      menuVisible: getScreenSize() !== "sm",
      expertQuestion: ""
    };
  },

  created() {
    window.addEventListener(
      "resize",
      debounce(this.calculatePlaybackWindowHeight, 200)
    );
    window.addEventListener("message", this.handleActivityMessage);
  },

  destroyed() {
    window.removeEventListener(
      "resize",
      debounce(this.calculatePlaybackWindowHeight, 200)
    );
    window.removeEventListener("message", this.handleActivityMessage);
  },

  mounted() {
    if (this.module.model === null) {
      this.fetchModule(this.$route.params.id);
    } else {
      this.initializeActivity();
    }
  },

  watch: {
    '$i18n.locale'(nextVal, val) {
      if(nextVal !== val) {
        this.fetchModule(this.$route.params.id);
      }
    },
    module(nextVal, val) {
      if (val.fetch && nextVal.fetchSuccess) {
        this.initializeActivity();
      }
      if (val.askExpert && nextVal.askExpertSuccess) {
        this.expertQuestion = "";
        Snackbar.show({
          text: this.$t('course_page.ask_expert_success_message'),
          duration: 0,
          actionText: this.$t('dismiss'),
        });
      }
    }
  },

  methods: {
    /**
     *
     */
    toggleMenuVisible() {
      this.menuVisible = !this.menuVisible;
      this.calculatePlaybackWindowHeight();
    },

    /**
     *
     */
    calculatePlaybackWindowHeight() {
      this.$nextTick(() => {
        if (this.$refs.playbackWindow) {
          this.playbackWindowHeight = this.$refs.playbackWindow.clientWidth / 1.78021;
        }
      });
    },

    /**
     *
     */
    displayMasterCertificateAwardVideo() {
      const documentBody = document.querySelector("body");
      const video = document.querySelector("#masterCertificateAward");

      if (video) {
        documentBody.classList.add("overflow-hidden");
        video.classList.remove("hidden");
        video.play();
        video.addEventListener("ended", event => {
          setTimeout(() => {
            documentBody.classList.remove("overflow-hidden");
            this.$router.push({name: 'CoursesPage'});
          }, 3500);
        });
      }
    },

    /**
     *
     */
    initializeActivity() {
      const lessons = this.module.model.lessons;

      if (lessons.length > 0) {
        this.lesson = lessons[0];
        if (this.lesson.activities.length > 0) {
          this.activity = this.lesson.activities[0];
        }

        this.module.model.lessons.every(lesson => {
          return lesson.activities.every(activity => {
            if (!activity.completed) {
              this.lesson = lesson;
              this.activity = activity;
              return false;
            }
            return true;
          });
        });
      }

      this.calculatePlaybackWindowHeight();
    },

    /**
     *
     * @param activity
     * @param lesson
     */
    setActivity(activity, lesson) {

        let allActivities = [];
        this.module.model.lessons.forEach(i => {
          allActivities = [...allActivities, ...(i.activities || [])];
        });
        const activityIndex = allActivities.findIndex(
          i => i.id === activity.id
        );

        if (
          !activity.completed &&
          activityIndex > 0 &&
          !allActivities[activityIndex - 1].completed
        ) {
          return;
        }

        if (lesson.id === this.lesson.id && activity.id === this.activity.id) {
          this.reloadActivity++;
        }

        this.activity = activity;
        this.lesson = lesson;
        this.nextActivityDialog = false;
        this.comingAssessmentDialog = false;

    },
    onSetActivity(activity,lesson){
      return event => {
      event.preventDefault();
      this.setActivity(activity,lesson)
      };
    },
    /**
     *
     * @param activity
     * @returns {*}
     */
    getActivityIcon(activity) {
      if (activity.completed) {
        return <i class="mdi mdi-check-circle text-green-400 mr-2"></i>;
      }

      return this.activity && this.activity.id === activity.id ? (
        <i class="mdi mdi-progress-check mr-2"></i>
      ) : (
        <i class="mdi mdi-check-circle text-gray-400 mr-2"></i>
      );
    },

    /**
     *
     * @param activity
     * @param lesson
     * @returns {string}
     */
    getActiveClass(activity, lesson) {
      if (this.activity && this.lesson) {
        if (this.activity.id === activity.id && this.lesson.id === lesson.id) {
          return "bg-action hover:bg-action-dark text-white";
        }
      }
      return "";
    },

    /**
     *
     * @param message
     */
    async handleActivityMessage(message) {
      switch (message.data) {
        case "nextActivity":
          //this.nextActivityDialog = true;
          this.startNextActivity();
          break;
        case "assessmentComing":
          this.comingAssessmentDialog = true;
          break;
        case "activityComplete":
          this.completeActivity(this.activity.id);
          this.fetchModules();
          break;
        case "activityStarted":
          this.startActivity(this.activity.id);
          break;
        case "reloadActivity":
          this.reloadActivity++;
          break;
        case "goCourses":
          this.fetchModules();
          this.$router.push({name: 'CoursesPage'});
          break;
        default: {
          if (message.data.event_id == "recordScore") {
            await this.scoreActivity(
              this.activity.id,
              message.data.data.score,
              message.data.data.answers
            );

            if (this.modules.collection.length > 0) {
              const completedAllActivities = this.modules.collection.every(
                module =>
                  module.lessons.every(lesson =>
                    lesson.activities.every(activity => !!activity.completed)
                  )
              );

              if (completedAllActivities) {
                this.fetchModules();
                this.displayMasterCertificateAwardVideo();
              }
            }
          }
        }
      }
    },

    /**
     *
     */
    startNextActivity() {
      const lessons = this.module.model ? this.module.model.lessons : [];

      const lessonIndex = lessons.map(i => i.id).indexOf(this.lesson.id);
      const activityIndex = lessons[lessonIndex].activities
        .map(i => i.id)
        .indexOf(this.activity.id);

      if (lessons[lessonIndex].activities[activityIndex + 1]) {
        this.activity = lessons[lessonIndex].activities[activityIndex + 1];
      } else if (
        lessons[lessonIndex + 1] &&
        lessons[lessonIndex + 1].activities[0]
      ) {
        this.lesson = lessons[lessonIndex + 1];
        this.activity = lessons[lessonIndex + 1].activities[0];
      } else {
        Snackbar.show({
          showAction: false,
          text: this.$t('course_page.no_more_activities'),
          customClass: "text-red-500",
          duration: 0,
          actionText: this.$t('dismiss'),
        });
      }

      this.nextActivityDialog = false;
    },

    /**
     *
     * @param resource
     * @returns {*}
     */
    getResourceIcon(resource) {
      if (resource.filename.includes("xlsx")) {
        return <i class="mdi mdi-file-excel mr-2"></i>;
      }
      return <i class="mdi mdi-file-pdf-box mr-2"></i>;
    },

    /**
     *
     * @param event
     */
    handleSubmitQuestion(event) {
      event.preventDefault();
      const message = this.expertQuestion;
      if (message.length > 0) {
        this.askAnExpert(this.module.model.id, message);
      }
    },

    /**
     *
     * @param activity
     * @returns {boolean}
     */
    showRestart(activity) {
      if (activity.completed) {
        return true;
      }

      return this.activity && this.activity.id === activity.id;
    },

    /**
     *
     */
    onFinishTourHandler() {
      this.menuVisible = getScreenSize() !== "sm";
    },

    /**
     *
     */
    onInitTourHandler() {
      this.menuVisible = true;
    },

    /**
     *
     */
    async activityComplete() {
      await this.completeActivity(this.activity.id);
      this.fetchModules();
    },
  },

  computed: {
    /**
     *
     * @returns {string|null}
     */
    iFrameSrc() {
      if (this.lesson && this.activity) {
        if(this.activity.path) {
          return (
            AxiosConfig.getStorageAddress() + "/" +
            this.activity.path +
            "/story.html?r=" +
            this.reloadActivity
          );
        }
        return (
          AxiosConfig.getStorageAddress() +
          "/modules/" +
          this.module.model.sequence +
          "/" +
          this.lesson.sequence +
          "/" +
          this.activity.sequence +
          "/story.html?r=" +
          this.reloadActivity
        );
      }
      return null;
    },

    /**
     *
     * @returns {null|*}
     */
    nextActivity() {
      const lessons = this.module.model ? this.module.model.lessons : [];

      if (!lessons.length || !this.lesson) {
        return this.activity;
      }

      const lessonIndex = lessons.map(i => i.id).indexOf(this.lesson.id);
      const activityIndex = lessons[lessonIndex].activities
        .map(i => i.id)
        .indexOf(this.activity.id);

      if (lessons[lessonIndex].activities[activityIndex + 1]) {
        return lessons[lessonIndex].activities[activityIndex + 1];
      } else if (
        lessons[lessonIndex + 1] &&
        lessons[lessonIndex + 1].activities[0]
      ) {
        return lessons[lessonIndex + 1].activities[0];
      }

      return null;
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const loading = this.module.fetch && <LoadingIndicator fill="black" class="mx-auto my-10 transform scale-150"/>;

    const menuToggle = (
      <button
        class="p-3 py-2 rounded-full bg-white text-blue-500 hover:underline focus:outline-none"
        onClick={this.toggleMenuVisible}
        id="menuToggle"
      >
        <i class={"mdi mr-3 " + (this.menuVisible ? "mdi-page-previous-outline" : "mdi-page-next-outline")}></i>
        {this.menuVisible ? this.$t('course_page.hide_menu') : this.$t('course_page.show_menu')}
      </button>
    );

    const lessonsList =
      this.module.model &&
      this.module.model.lessons.map(lesson => (
        <ul class="p-3 pb-5 lessons-list">
          <li class="font-bold">
            {lesson.name}
          </li>
          {lesson.activities.map(activity => (
            <li key={activity.name}>
              <div class={"cursor-pointer rounded p-3 relative " + this.getActiveClass(activity, lesson)}
                   onClick={this.onSetActivity(activity, lesson)}>
                <div class="flex lg:items-center">
                  {this.getActivityIcon(activity)}
                  <div>{activity.name}</div>
                </div>
                {this.showRestart(activity) && (
                  <div class="absolute top-0 bottom-0 left-0 right-0 p-px">
                    <div class="flex items-center justify-end p-3 rounded hover:bg-gray-200 text-transparent hover:text-blue-500 hover:underline h-full transition transition-colors ease-out duration-150">
                      {this.$t('course_page.restart')}
                      <i class="mdi mdi-restart ml-2"></i>
                    </div>
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      ));

    const nextActivityDialog = this.nextActivityDialog && (
      <div class="absolute top-0 left-0 h-full w-full z-10 bg-black-75 flex items-center justify-center">
        <div class="text-white text-center">
          <h4 class="font-bold mb-5">
            {this.$t('course_page.next_up')}
          </h4>
          {this.nextActivity && <h2 class="mb-5">{this.nextActivity.name}</h2>}
          {!!this.nextActivity && (
            <button
              class="block mx-auto px-5 p-2 lg:p-3 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none text-base "
              type="button" onClick={this.startNextActivity}>
              {this.$t('course_page.start')}
              <i class="mdi mdi-arrow-right ml-5"></i>
            </button>
          )}
          {!!this.nextActivity || (
            <router-link to={{name: 'CoursesPage'}} class="block mx-auto px-5 p-2 lg:p-3 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none text-base ">
              {this.$t('course_page.return_to_my_courses')}
              <i class="mdi mdi-arrow-right ml-2"></i>
            </router-link>
          )}
        </div>
      </div>
    );

    const resources = (
      <ul class="bg-white pb-10 mb-10" id="resources">
        <li>
          <h3 class="font-bold text-xl p-5">
            {this.$t('course_page.resources')}
          </h3>
        </li>
        {this.module.model &&
        this.module.model.resources.map((resource, i) => (
          <li class={classNames("border-t", {"border-b": i === (this.module.model.resources.length -1)})}>
            <a href={getResourceLink(resource)} target="_blank" class="p-5 py-3 flex items-center text-blue-500 hover:underline">
              {this.getResourceIcon(resource)}
              <span>
                {resource.name}
              </span>
              <i class="mdi mdi-download ml-auto text-2xl"></i>
            </a>
          </li>
        ))}
      </ul>
    );
    
    const askExpert = (
      <div class="bg-white p-5" id="askExpert">
        <h3 class="font-bold text-xl mb-5">
          {this.$t('course_page.need_help')}
        </h3>
        <div class="py-2">
          
            <router-link to={{name: 'HelpPage'}} class="flex-shrink-0 lg:mr-8 mb-3 lg:mb-0 p-2 px-5 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline">
            {this.$t('yes')}
            <i class="mdi mdi-arrow-right ml-3"></i>
            </router-link>
            
          </div>
      </div>
    );

    const moduleIsChangeManagement = this.module.model && this.module.model.name == "Change Management";

    const pageContent = this.module.model && (
      <div>
        {moduleIsChangeManagement || (
          <div class="bg-gray-300">
            <div class="container mx-auto px-3 lg:px-6">
              <div class="flex flex-col-reverse lg:flex-row lg:items-center py-3">
                {menuToggle}
                <div class="lg:px-6 pb-3 lg:pb-0">
                  <router-link to={{name: 'CoursesPage'}} class="font-bold text-blue-500 hover:underline">
                    {this.$t('courses')}
                  </router-link>
                  {' / '}
                  {this.$t('course_sequence_name', {
                    sequence: this.module.model.sequence,
                    name: this.module.model.name
                  })}
                </div>
              </div>
            </div>
          </div>
        )}

        {moduleIsChangeManagement && (
          <ChangeManagement
            module={this.module}
            lesson={this.lesson}
            activity={this.activity}
            iframesrc={this.iFrameSrc}
            onSetact={this.setActivity}
            onComplete={this.activityComplete}/>
        )}

        {moduleIsChangeManagement || (
          <div class="bg-gray-300">
            <div class="container mx-auto px-3 lg:px-6">
              <div class="flex flex-wrap pb-5">
                {this.menuVisible && (
                  <div class="w-full lg:w-1/4 lg:overflow-y-auto" style={{ height: getScreenSize() === "sm" ? "unset" : (this.playbackWindowHeight + "px") }}>
                    <div class="bg-white mb-5 lg:mb-0">
                      {lessonsList}
                    </div>
                  </div>
                )}
                <div class={classNames("w-full h-full", {"lg:w-3/4 lg:pl-5": this.menuVisible})}>
                  <div class="bg-accent h-full mt-5 lg:mt-0 relative" ref="playbackWindow" id="playbackWindow" style={{ height: this.playbackWindowHeight + "px" }}>
                    <iframe src={this.iFrameSrc} width="100%" height="100%"/>
                    {nextActivityDialog}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div class="bg-gray-300">
          <div class="container mx-auto px-3 lg:px-6">
            <div class="flex flex-col-reverse lg:flex-row py-5">
              <div class="lg:w-8/12" id="comments">
                <Comments module={this.module.model} />
              </div>
              <div class="lg:w-4/12 lg:pl-6 pb-10 lg:pb-0">
                {resources}
                {askExpert}
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    const masterCertificateAward = (
      <video id="masterCertificateAward" class="hidden fixed left-0 top-0 w-screen h-screen z-50 transform scale-125 lg:scale-100" style="background: #4c5f72;">
        <source src={require("../assets/masterCertificateAward.mp4")} type="video/mp4" />
      </video>
    );

    return (
      <PageTemplate navProps={{ sticky: false }}>
        {loading}
        {pageContent}
        {masterCertificateAward}
        <CoursePageTour
          $menuToggle={'#menuToggle'}
          $commentsContainer={'#comments'}
          $askExpertContainer={'#askExpert'}
          $resourcesContainer={'#resources'}
          $playbackWindow={'#playbackWindow'}
          initHandler={this.onInitTourHandler}
          finishHandler={this.onFinishTourHandler}
          $activeLessonItem={'.lessons-list .bg-action hover:bg-action-dark'}
        />
      </PageTemplate>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    module: state.module,
    modules: state.modules
  };
}

function mapActionToProps(dispatch) {
  return {
    fetchModule: id => dispatch(moduleActions.fetchModule(id)),
    startActivity: id => dispatch(moduleActions.startActivity(id)),
    completeActivity: id => dispatch(moduleActions.completeActivity(id)),
    scoreActivity: async (id, score, answers) =>
      await dispatch(moduleActions.scoreActivity(id, score, answers)),
    askAnExpert: (id, message) =>
      dispatch(moduleActions.askAnExpert(id, message)),
    fetchModules: () => dispatch(modulesActions.fetchModules()),
  };
}

export default connect(mapStateToProps, mapActionToProps)(CoursePage);